<script setup>
import {
  AudioWaveform,
  BookOpen,
  Bot,
  Command,
  GalleryVerticalEnd,
  UsersRound,
  SquareChartGantt,
  Settings,
} from "lucide-vue-next";
import NavMain from '@/components/NavMain.vue';
import NavUser from '@/components/NavUser.vue';

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '@/components/ui/sidebar';

import {
  SidebarTrigger,
} from '@/components/ui/sidebar'

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  side: { type: String, required: false },
  variant: { type: String, required: false },
  collapsible: { type: String, required: false, default: "icon" },
  class: { type: null, required: false },
  projects: {type: Array, required: true},
  actionView: String,
});

const { t } = useI18n();

// This is sample data.
const data = {
  user: {
    name: "shadcn",
    email: "m@example.com",
    avatar: "/avatars/shadcn.jpg",
  },
  teams: [
    {
      name: "Acme Inc",
      logo: GalleryVerticalEnd,
      plan: "Enterprise",
    },
    {
      name: "Acme Corp.",
      logo: AudioWaveform,
      plan: "Startup",
    },
    {
      name: "Evil Corp.",
      logo: Command,
      plan: "Free",
    },
  ],
  navMain: [
    {
      title: t('view.planner'),
      url: "planner",
      icon: SquareChartGantt,
    },
    {
      title: t('view.projects'),
      url: "projects",
      icon: Bot,
    },
    {
      title: t('view.bookings'),
      url: "bookings",
      icon: BookOpen,
    },
    {
      title: t('view.resources'),
      url: "resources",
      icon: UsersRound,
    },
	{
	  title: t('view.settings'),
	  url: "settings",
	  icon: Settings,
	},
  ],
};

const isSidebarOpen = ref(true)

function toggleSidebar() {
  isSidebarOpen.value = !isSidebarOpen.value
}

</script>

<template>
  <Sidebar v-bind="props">
	
    <SidebarHeader>
		  <div class="flex items-center space-x-3 p-4 border-b">
		    <SidebarTrigger class="-ml-1"  @click="toggleSidebar" />
		    <img v-if="isSidebarOpen" src="@/components/images/timin.svg" alt="Timin Logo" class="w-12 object-contain" />
		  </div>

    </SidebarHeader>
    <SidebarContent>
      <NavMain :items="data.navMain" :projects="props.projects" @updateView="actionView = $event" />
    </SidebarContent>
    <SidebarFooter>
      <NavUser :user="data.user" />
    </SidebarFooter>
    <SidebarRail />
  </Sidebar>
</template>
